import { render, staticRenderFns } from "./SettingsDialog.vue?vue&type=template&id=57beb021&scoped=true&"
import script from "./SettingsDialog.vue?vue&type=script&lang=js&"
export * from "./SettingsDialog.vue?vue&type=script&lang=js&"
import style0 from "./SettingsDialog.vue?vue&type=style&index=0&id=57beb021&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57beb021",
  null
  
)

export default component.exports